module.exports = __webpack_public_path__ + "img/shopify-limitations-for-e-commerce-img-4.4d8ee49e.webp";